import { render, staticRenderFns } from "./EditName.vue?vue&type=template&id=7b195e04&scoped=true&"
import script from "./EditName.vue?vue&type=script&lang=js&"
export * from "./EditName.vue?vue&type=script&lang=js&"
import style0 from "./EditName.vue?vue&type=style&index=0&id=7b195e04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b195e04",
  null
  
)

export default component.exports